import React, { Component } from 'react';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import Toggle from './../Toggle';
import Disclaimer from '../Disclaimer';
import { withTranslation, Trans } from 'react-i18next';
import { ownerscabinImageOptions } from './views/ownerscabin'

class OwnersCabin extends Component {
    constructor(props) {
		super(props);
		this.handleCupboardsChange = this.handleCupboardsChange.bind(this);
		this.handleFabricChange = this.handleFabricChange.bind(this);
    }


	handleCupboardsChange(event) {
		let configuration = this.props.configuration;
		configuration.CupboardsOwnersCabin = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

	handleFabricChange(newValue) {
		let configuration = this.props.configuration;
		configuration.FabricOwnersCabin = newValue;
		configuration.FabricAftCabin = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}
    render() {
		let imageOptions = ownerscabinImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>


					<h1><Trans defaults='Owners cabin' /></h1>
					<h2><Trans defaults='Furniture' /></h2>
					<p><Trans defaults='To add more storage or cargo space in the owners cabin, you have an option for upper cupboards.' /></p>
					<p><Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint - and if optional upper cupboards are selected, the lighting is fitted below the cupboards.' /></p>
					<Toggle checked={this.props.configuration.CupboardsOwnersCabin.value === 2} onChange={this.handleCupboardsChange}>
						<Trans defaults='Upper cupboards' />
					</Toggle>

					<h2><Trans defaults='Fabrics' /></h2>
					<MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.FabricOwnersCabin.label} value={this.props.configuration.FabricOwnersCabin} onChange={this.handleFabricChange} />


                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(OwnersCabin);


// WEBPACK FOOTER //
// ./src/X43MK2/OwnersCabin.js